import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

export const shakeMs = 800;
export const shake = trigger('shake', [
  transition('start => end', [
    animate(`${shakeMs}ms ease-in`,
      keyframes([
        style({transform: `translateX(-1px)`, offset: .1 }),
        style({transform: `translateX(2px)`, offset: .2 }),
        style({transform: `translateX(-4px)`, offset: .3 }),
        style({transform: `translateX(4px)`, offset: .4 }),
        style({transform: `translateX(-4px)`, offset: .5 }),
        style({transform: `translateX(4px)`, offset: .6 }),
        style({transform: `translateX(-4px)`, offset: .7 }),
        style({transform: `translateX(2px)`, offset: .8 }),
        style({transform: `translateX(-1px)`, offset: .9 })
      ])
    )
  ])
]);
